<ag-grid-angular
  class="ag-grid-theme-gallagher"
  [gridOptions]="gridOptions"
  [rowData]="rowData"
  [getRowClass]="getRowClass"
  [domLayout]="domLayout"
  (cellKeyDown)="onKeydown($event)">
</ag-grid-angular>
